import React, { useState } from 'react';
import { format } from 'date-fns';
import { ExternalLink, ThumbsUp, ThumbsDown } from 'lucide-react';
import { getConfig } from '../config';
import './ResultsTable.css';

const ResultsTable = ({ comments, onAuthorClick }) => {
  const config = getConfig();
  const [sortField, setSortField] = useState('datetime');
  const [sortDirection, setSortDirection] = useState('desc');

  const handleAuthorClick = (author) => {
    if (onAuthorClick) {
      onAuthorClick(author);
    } else {
      // Fallback: обновляем URL напрямую
      const urlParams = new URLSearchParams();
      urlParams.set('author', author);
      window.location.href = `${window.location.pathname}?${urlParams.toString()}`;
    }
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedComments = [...comments].sort((a, b) => {
    let aValue = a[sortField];
    let bValue = b[sortField];

    // Специальная обработка для даты
    if (sortField === 'datetime') {
      aValue = new Date(aValue);
      bValue = new Date(bValue);
    }

    // Специальная обработка для числовых полей
    if (['rating_plus', 'rating_minus'].includes(sortField)) {
      aValue = Number(aValue);
      bValue = Number(bValue);
    }

    if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
    if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, config.ui.dateFormat);
    } catch {
      return dateString;
    }
  };

  const truncateContent = (content, maxLength = config.ui.contentPreviewLength) => {
    if (content.length <= maxLength) return content;
    return content.substring(0, maxLength) + '...';
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortDirection === 'asc' ? '↑' : '↓';
  };

  return (
    <div className="results-table-container">
      <div className="table-wrapper">
        <table className="results-table">
          <thead>
            <tr>
              <th>Комментарий</th>
              <th onClick={() => handleSort('author')}>
                Автор {getSortIcon('author')}
              </th>
              <th onClick={() => handleSort('rating_plus')}>
                 Рейтинг {getSortIcon('rating_plus')}
              </th>
              <th onClick={() => handleSort('datetime')}>
                Ссылка / Дата {getSortIcon('datetime')}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedComments.map((comment) => (
              <tr key={comment.id} className="comment-row">
                <td className="comment-content">
                  <div className="content-preview">
                    {truncateContent(comment.content)}
                  </div>
                  {comment.content.length > config.ui.contentPreviewLength && (
                    <div className="content-full" title={comment.content}>
                      {comment.content}
                    </div>
                  )}
                </td>
                <td className="comment-author">
                  <strong>
                    <a
                      href={`?author=${encodeURIComponent(comment.author)}`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleAuthorClick(comment.author);
                      }}
                      className="author-link"
                      title={`Поиск всех комментариев автора ${comment.author}`}
                    >
                      {comment.author}
                    </a>
                  </strong>
                </td>
                <td className="comment-rating rating-plus">
                  <ThumbsUp size={16} />
                  {comment.rating_plus}
                </td>
                <td className="comment-rating rating-minus">
                  <ThumbsDown size={16} />
                  {comment.rating_minus}
                </td>
                <td className="comment-link">
                  <div className="link-container">
                    {comment.post_link && (
                      <a
                        href={comment.post_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link-btn"
                        title={`ID: ${comment.id} - Открыть пост`}
                      >
                        <span className="link-id">{comment.id}</span>
                        <ExternalLink size={16} />
                      </a>
                    )}
                    {!comment.post_link && (
                      <span className="link-id-only">{comment.id}</span>
                    )}
                    <div className="link-datetime">
                      {formatDate(comment.datetime)}
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {comments.length === 0 && (
        <div className="no-results">
          <p>Комментарии по вашему запросу не найдены.</p>
        </div>
      )}
    </div>
  );
};

export default ResultsTable; 